import AlertsApp from './containers/AlertsApp'
export default AlertsApp
